import { Button, Modal } from "react-bootstrap";
import "./styles.scss";

interface ModalInfoProps {
  text: string;
  icon?: React.ReactNode;
  show?: boolean;
  onHide?: () => void;
}

export const ModalInfo = ({ text, icon, show, onHide }: ModalInfoProps) => {
  return (
    <Modal
      className="d-flex flex-column"
      centered={true}
      show={show}
      onHide={onHide}
    >
      <div className="modal-info-container d-flex flex-column">
        <div className="register-subtitle2 text-center px-3">
          {icon && <div className="d-flex justify-content-center">{icon}</div>}
          <div className="ml-3 fs-6 fw-bold">{text}</div>
        </div>

        <div className="d-flex justify-content-end mt-4">
          <Button
            className="btn-confirm-info mx-auto text-center fw-bold"
            type="submit"
            onClick={onHide}
          >
            OK
          </Button>
        </div>
      </div>
    </Modal>
  );
};
